




























































































import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import CarDetail from '@/components/CarDetail.vue';
import {
  SelectedAttributeModel,
  AttributeFilterParams,
  AttributePriceParams,
} from '@/models/AttributeModel';
import VehicleDetail, { YearModel } from '@/models/VehicleDetail';
import OrderDetailModel, {
  CommunicationModel,
} from '@/models/OrderDetailModel';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';
import router from '@/router';
import OrderService from '@/services/order.service';
import BaseServiceMixin from '@/mixins/base.service.mixin';
import ConfigurationService from '../services/configuration.service';
import Shared from '../common/shared';
import VehicleService from '@/services/vehicle.service';
import { Config } from '@/common/config';
import { AttributeTypes } from '../common/enum';
import ConfigurationModel from '../models/ConfigurationModel';
import eventBus from '../common/bus';

@Component({
  name: 'ConfirmMatSelection',
  components: {
    CarDetail,
  },
})
export default class ConfirmMatSelection extends Mixins(BaseServiceMixin) {
  @Prop({ default: undefined })
  public vehicleDetail!: VehicleDetail;
  @Prop() private selectedAttributes!: SelectedAttributeModel[];
  private communication: CommunicationModel = {} as CommunicationModel;
  private orderDetail: OrderDetailModel = new OrderDetailModel();
  private loading: boolean = false;
  private communicationDialog: boolean = false;
  private store = getModule(StoreVuexModule, this.$store);
  private price = 0;
  private loadingPrice = false;

  private orderService!: OrderService;
  private vehicleService!: VehicleService;
  private configurationService!: ConfigurationService;

  public created() {
    this.orderService = new OrderService(this.axiosInstance);
    this.vehicleService = new VehicleService(this.axiosInstance);
    this.configurationService = new ConfigurationService(this.axiosInstance);
  }

  private async mounted() {
    //
  }

  private async getConfiguration(): Promise<ConfigurationModel> {
    return this.configurationService.GetFilteredConfigurations(
      this.selectedAttributes
        .filter((a) =>
          [
            AttributeTypes.CarpetSpec,
            AttributeTypes.Trim,
            AttributeTypes.HeelPad,
          ].includes(a.type),
        )
        .map((a) => ({ attributeId: a.id, type: a.type, isParent: true })),
    );
  }

  private async onConfirmation() {
    try {
      this.loading = true;
      const configuration = await this.getConfiguration();
      const postData: Record<string, string | number | number[]> = {
        configurationId: configuration.id,
        manufacturerId: this.vehicleDetail.makeId,
        modelGroupId: this.vehicleDetail.modelGroupId,
        modelId: this.vehicleDetail.modelId,
        generation: this.vehicleDetail.yearModel.generation,
        seatCount: this.vehicleDetail.seats,
        transmissionId: this.vehicleDetail.transmissionId,
        attributes: this.selectedAttributes
          .filter((a) =>
            [AttributeTypes.CarpetColor, AttributeTypes.TrimColor].includes(
              a.type,
            ),
          )
          .map((a) => a.id),
      };
      const product = await this.configurationService.GetProduct(postData);
      if (product) {
        eventBus.$emit('track', 'GoToProduct', { product });
      }
      if (product && this.store.parentOrigin) {
        window.parent.postMessage(`${product.code}`, this.store.parentOrigin);
      } else {
        this.$emit('notFound');
      }
    } catch (error) {
      // Handle Error
    } finally {
      this.loading = false;
    }
  }

  private onBackBtnClick() {
    eventBus.$emit('track', 'BackToConfiguration', {});
    this.$emit('clickContinue', 2);
  }
}
